import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// ui related
import {
  Typography,
  List,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Box,
} from "@mui/material";
import { HelpChip } from "Components/BusinessView/HelpChip";

//icons
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import BrushRoundedIcon from "@mui/icons-material/BrushRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";

type DrawerProps = {
  onSelected: (pageName: string) => void;
};

export const HubDrawer = ({ onSelected }: DrawerProps) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [selectedPage, setSelectedPage] = useState(currentPath);

  useEffect(() => {
    setSelectedPage(currentPath);
  }, [currentPath]);

  return (
    <List component="nav" disablePadding sx={{ height: "100%" }}>
      <ListItemButton
        selected={selectedPage.endsWith("/admin/home")}
        onClick={() => {
          setSelectedPage("/admin/home");
          navigate("/admin/home");
          if (onSelected) {
            onSelected("/admin/home");
          }
        }}
      >
        <ListItemIcon>
          <BrushRoundedIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography flex={1} variant="body2" sx={{ fontWeight: 600 }}>
              Editor
            </Typography>
          }
        />
      </ListItemButton>
      <ListItemButton
        selected={selectedPage === "/admin/customers"}
        onClick={() => {
          setSelectedPage("/admin/customers");
          navigate("/admin/customers");
          if (onSelected) {
            onSelected("/admin/customers");
          }
        }}
      >
        <ListItemIcon>
          <PeopleAltRoundedIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography flex={1} variant="body2" sx={{ fontWeight: 600 }}>
              Customers
            </Typography>
          }
        />
      </ListItemButton>
      <Box sx={{ position: "absolute", bottom: 0, width: "100%" }}>
        <ListItemButton
          onClick={() => window.open("https://flowlyapp.com/", "_blank")}
        >
          <ListItemIcon>
            <AppsRoundedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography flex={1} variant="body2" sx={{ fontWeight: 600 }}>
                More tools
              </Typography>
            }
          />
        </ListItemButton>
        <HelpChip />
        <ListItemButton
          onClick={() => {
            //setSelectedPage("account");
            if (onSelected) {
              onSelected("account");
            }
          }}
        >
          <ListItemIcon>
            <LogoutRoundedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography flex={1} variant="body2" sx={{ fontWeight: 600 }}>
                Sign out
              </Typography>
            }
          />
        </ListItemButton>
      </Box>
    </List>
  );
};
